import { useMediaQuery } from 'usehooks-ts'
import useDetectInstagramUA from '~/src/hooks/useDetectInstagramUA'

// Use matchMedia to detect screen size (matches Tailwind's md breakpoint)
const useDeviceDetect = () => {
  const { isInstagram, loading: isInstagramLoading } = useDetectInstagramUA()

  const isMobile = useMediaQuery('(max-width: 767px)')
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1023px)')
  const isDesktop = useMediaQuery('(min-width: 768px)')

  return {
    isMobile,
    isTablet,
    isDesktop,
    isInstagram,
    loading: isInstagramLoading,
  }
}

export default useDeviceDetect
